"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelect = void 0;
var polished_1 = require("polished");
var react_1 = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var styles_1 = require("./styles");
var styled_components_1 = __importStar(require("styled-components"));
var LabelAndHelpText_1 = require("../Shared/LabelAndHelpText");
var CustomSingleValue = function (props) { return react_1.default.createElement(react_select_1.components.SingleValue, __assign({}, props)); };
var StyledOption = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  cursor: pointer;\n"], ["\n  padding: ", ";\n  cursor: pointer;\n"])), (0, polished_1.rem)(8));
var CustomOption = function (props) {
    var isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, data = props.data;
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement(StyledOption, __assign({}, innerProps, { ref: innerRef, style: __assign(__assign({}, props.innerProps.style), { backgroundColor: isFocused
                ? colors.background.secondary
                : 'transparent', color: data.isDisabled ? colors.text.disabled : colors.text.primary, cursor: 'pointer' }) }), props.data.label));
};
/**
 * The `SingleSelect` component is a customizable dropdown selector built using react-select.
 * It allows users to select a single option from a list of predefined values, with support for error handling and keyboard navigation.
 *
 * Key features include:
 *
 * - **Customizable Options**: Options can be defined with labels and values. The appearance of each option is styled based on focus and hover states.
 * - **Keyboard Navigation**: Built-in support for keyboard navigation ensures accessibility, allowing users to navigate the dropdown using the keyboard.
 * - **Dynamic Styling**: The component integrates with the theme to style the dropdown, placeholder text, border, and menu dynamically based on the current focus and error state.
 * - **Error Handling**: If an error message is provided, the border and error message are visually styled to indicate validation issues.
 * - **Dropdown Behavior**: The dropdown opens on focus and closes upon selection, with a Chevron icon to indicate the state of the dropdown.
 */
var SingleSelect = function (_a) {
    var id = _a.id, className = _a.className, onChange = _a.onChange, placeholder = _a.placeholder, _b = _a.options, options = _b === void 0 ? [] : _b, error = _a.error, selectedValue = _a.selectedValue, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, additionalText = _a.additionalText;
    var _d = (0, react_1.useState)(false), isMenuOpen = _d[0], setIsMenuOpen = _d[1];
    var _e = (0, react_1.useState)(false), isKeyboardNavigation = _e[0], setIsKeyboardNavigation = _e[1];
    var colors = (0, styled_components_1.useTheme)().colors;
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            if (event.key === 'Tab') {
                setIsKeyboardNavigation(true);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });
    var handleFocus = function () {
        setIsMenuOpen(true);
    };
    var handleBlur = function () {
        setIsMenuOpen(false);
        setIsKeyboardNavigation(false);
    };
    var customStyles = {
        placeholder: function (provided) { return (__assign(__assign({}, provided), { color: colors.text.secondary })); },
        indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { display: 'none', height: 0 })); },
        dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { display: 'flex', alignItems: 'center', height: '100%', padding: (0, polished_1.rem)(8), ':hover': {
                cursor: 'pointer',
            } })); },
        control: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: (0, polished_1.rem)(12), border: state.isFocused
                ? "1px solid ".concat(colors.border.primary)
                : error
                    ? "1px solid ".concat(colors.border.error)
                    : "1px solid ".concat(colors.border.secondary), transition: 'border 0.5s ease', display: 'flex', justifyContent: 'center', boxShadow: 'none', padding: (0, polished_1.rem)(8), ':hover': {
                border: "1px solid ".concat(colors.border.primary),
            } })); },
        valueContainer: function (provided) { return (__assign(__assign({}, provided), { borderRadius: (0, polished_1.rem)(12) })); },
        option: function (provided, state) { return (__assign(__assign({}, provided), { cursor: 'pointer', backgroundColor: state.isFocused
                ? colors.background.secondary
                : 'transparent', color: state.isDisabled ? colors.text.disabled : colors.text.primary, ':hover': {
                backgroundColor: colors.background.secondary,
            } })); },
        menu: function (provided) { return (__assign(__assign({}, provided), { borderRadius: (0, polished_1.rem)(12), zIndex: 2, backgroundColor: colors.background.card, border: "".concat((0, polished_1.rem)(1), " solid ").concat(colors.border.primary), boxShadow: isKeyboardNavigation
                ? "0 0 0 ".concat((0, polished_1.rem)(3), " ").concat(colors.border.primary)
                : 'none' })); },
        menuList: function (provided) { return (__assign(__assign({}, provided), { borderRadius: (0, polished_1.rem)(12), border: 'none', transition: 'border 0.5s ease, margin 0.5s ease', backgroundColor: colors.background.card })); },
    };
    var props = {};
    if (selectedValue) {
        var option = options.find(function (o) { return o.value === selectedValue; });
        if (option) {
            props.value = option;
        }
    }
    if (id) {
        props.inputId = id;
    }
    return (react_1.default.createElement(styles_1.DropdownContainer, { error: Boolean(error), className: "".concat(className).concat(isDisabled ? ' disabled' : '') },
        additionalText && (react_1.default.createElement(LabelAndHelpText_1.LabelAndHelpText, { id: id || '', label: additionalText.label, helpText: additionalText.helpText })),
        error && react_1.default.createElement(styles_1.ErrorMessage, null, error),
        react_1.default.createElement(react_select_1.default, __assign({}, props, { options: options, styles: customStyles, isMulti: false, onChange: function (newValue) {
                var _a;
                onChange((_a = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _a !== void 0 ? _a : null);
            }, onFocus: handleFocus, onBlur: handleBlur, closeMenuOnSelect: true, blurInputOnSelect: true, placeholder: placeholder, menuIsOpen: isMenuOpen, components: {
                SingleValue: CustomSingleValue,
                Option: CustomOption,
                DropdownIndicator: function () { return (react_1.default.createElement(styles_1.Container, null,
                    react_1.default.createElement(styles_1.ChevronIcon, { rotation: isMenuOpen ? 'up' : 'down' }))); },
            }, isDisabled: isDisabled }))));
};
exports.SingleSelect = SingleSelect;
var templateObject_1;
